import { connect } from 'react-redux';

import Radio from '../../components/Inputs/Radio';

const mapStateToProps = (state, props) => {
  const [store, ...storeKey] = props.storeKey.split('.');
  storeKey.push('value');
  return ({
    value: state[store].getIn(storeKey),
  });
};

export default connect(mapStateToProps)(Radio);
